export default "__VITE_ASSET__DJLW3Bh5__"